import { render, staticRenderFns } from "./viewCourseware.vue?vue&type=template&id=2c864c3c&scoped=true&"
import script from "./viewCourseware.vue?vue&type=script&lang=js&"
export * from "./viewCourseware.vue?vue&type=script&lang=js&"
import style0 from "./viewCourseware.vue?vue&type=style&index=0&id=2c864c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c864c3c",
  null
  
)

export default component.exports